import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useAdaptiveTextColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompTextFieldWrapperCore } from '../core/forms/text-field/wrapper'
import { CompTextField } from './CompTextField'

/**
 * CompTextFieldWrapper
 */
function CompTextFieldWrapper() {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useAdaptiveTextColor()
  const infosProps = { ...compContext, currentParentBg, activeLayer }

  // form
  const formContext = useCompFormContext()

  return (
    <CompTextFieldWrapperCore infos={infosProps} form={formContext}>
      {(props) => <CompTextField {...props} />}
    </CompTextFieldWrapperCore>
  )
}

export default CompTextFieldWrapper
